import { render, staticRenderFns } from "./SelectionType.vue?vue&type=template&id=181b0482&"
import script from "./SelectionType.vue?vue&type=script&lang=js&"
export * from "./SelectionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports